import React from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import MeetingsContainer from '../containers/meetings';

export default function MeetingsPage(props) {
  return <MeetingsContainer />;
}
